import { render, staticRenderFns } from "./wheel-of-fortune.vue?vue&type=template&id=fb375b38&scoped=true"
import script from "./wheel-of-fortune.vue?vue&type=script&lang=js"
export * from "./wheel-of-fortune.vue?vue&type=script&lang=js"
import style0 from "./wheel-of-fortune.vue?vue&type=style&index=0&id=fb375b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb375b38",
  null
  
)

export default component.exports